// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
// Default: Production Supabase
// To use local Supabase, create .env.local file with: VITE_USE_LOCAL_SUPABASE=true
const USE_LOCAL = import.meta.env.VITE_USE_LOCAL_SUPABASE === 'true';

const SUPABASE_URL = USE_LOCAL
  ? "http://127.0.0.1:54321"
  : "https://mavi-supabase.novaforge.tech";

const SUPABASE_PUBLISHABLE_KEY = USE_LOCAL
  ? import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzc1MzM2NDAwLCJleHAiOjE5MzMxMDI4MDB9.yeNfnnJ8dCVAM6QR2duWoAcY2RquBNvEd0Ldgik_UXM";

  // Debug info (only in development)
if (import.meta.env.DEV) {
  console.log(`🔗 Supabase Connection: ${USE_LOCAL ? 'LOCAL 🏠' : 'PRODUCTION 🌐'}`);
  console.log(`📡 URL: ${SUPABASE_URL}`);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
